<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-row :gutter="[24, 8]">
        <a-col :span="24">
          <a-form-item label="头像" name="headShot">
            <img-upload v-model:value="form.headShot" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="姓名" name="name">
            <a-input v-model:value="form.name" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="性别" name="sex">
            <a-select v-model:value="form.sex" :options="sexData" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="出生日期" name="dateBirth">
            <DatePicker style="width: 100%" v-model:value="form.dateBirth" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="身份证号码" name="identityCardNumber">
            <a-input v-model:value="form.identityCardNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="联系电话" name="phoneNumber">
            <a-input v-model:value="form.phoneNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮箱" name="emailAddress">
            <a-input v-model:value="form.emailAddress" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="现居住地" name="prov">
            <city-select-all v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
              placeholder="请选择省/市/区" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="详细地址" name="detailedAddress">
            <a-input v-model:value="form.detailedAddress" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="参加工作时间" name="timeWork">
            <DatePicker style="width: 100%" v-model:value="form.timeWork" :format="dateFormat.DATE_DAY"
              :showTime="false" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="学历" name="educationBackground">
            <DictSelect v-model:value="form.educationBackground" :dict-name="education.EDUCATION_BACKGROUND"
              placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="是否为应届生" name="freshGraduate">
            <a-select v-model:value="form.freshGraduate" :options="freshGraduateData" placeholder="请选择" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="个人简介" name="personalProfile">
            <a-textarea v-model:value="form.personalProfile" placeholder="请输入" :auto-size="{ minRows: 4, maxRows: 6 }" />
          </a-form-item>
        </a-col>
      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { personalCenterInfo } from "@/api/educationService";
import DictSelect from "@/components/other/DictSelect";
import CitySelectAll from "@/components/form/select/AllCitySelect";
import DatePicker from "@/components/form/datePicker/DatePicker";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect, DatePicker, CitySelectAll },
  mixins: [formMixin],
  data() {
    return {
      sexData: [{ label: '男', value: '0' }, { label: '女', value: '1' }],
      freshGraduateData: [{ label: '是', value: '0' }, { label: '否', value: '1' }],
      education,
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        phoneNumber: [dataCheck.required({}), dataCheck.mobile_phone,],
        name: [dataCheck.required({})],
        identityCardNumber: [dataCheck.required({}), dataCheck.id_num],
        emailAddress: [dataCheck.email],
        detailedAddress: [],
        prov: [],
        city: [],
        dist: [],
        sex: [],
        dateBirth: [],
        timeWork: [],
        educationBackground: [],
        freshGraduate: [],
        personalProfile: [],
        headShot: [],
        id: [],
      },
      submitUrl: personalCenterInfo.saveupdate
    }
  },
}
</script>
<style scoped lang="less"></style>
